import { render, staticRenderFns } from "./VideoListItem.vue?vue&type=template&id=3b19a78d&"
import script from "./VideoListItem.vue?vue&type=script&lang=js&"
export * from "./VideoListItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports